"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionsColumn = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _dxReactCore = require("@devexpress/dx-react-core");
var _dxReactGridMaterialUi = require("@devexpress/dx-react-grid-material-ui");
var _styles = require("@mui/styles");
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _getResource = require("../../utilities/getResource");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var pluginDependencies = [{
  name: 'Table'
}];
var ACTIONS_COLUMN_TYPE = 'actionsColumnType';
var TABLE_HEADING_TYPE = 'heading';
var tableColumnsWithActions = function tableColumnsWithActions(tableColumns, width) {
  return [].concat(tableColumns, [{
    key: ACTIONS_COLUMN_TYPE,
    type: ACTIONS_COLUMN_TYPE,
    width: width
  }]);
};
var isHeadingActionsTableCell = function isHeadingActionsTableCell(tableRow, tableColumn) {
  return tableRow.type === TABLE_HEADING_TYPE && tableColumn.type === ACTIONS_COLUMN_TYPE;
};
var isActionsTableCell = function isActionsTableCell(tableRow, tableColumn) {
  return tableRow.type !== TABLE_HEADING_TYPE && tableColumn.type === ACTIONS_COLUMN_TYPE;
};
var getActionText = function getActionText(action, rowData, resources, language, pageProgress) {
  //loop through pageProgress, check if any keys contain rowData.entityID, if they do check its percentComplete if thats > 0 then the STart button should say Continue
  //If all pages for this entity are 100% then it should say Completed
  var entityStatus = 'Start';
  var allPagesDone = false;
  if (!(0, _lodash.isEmpty)(pageProgress) && pageProgress) {
    var pageArray = Object.entries(pageProgress); //create an array of arrays that we can map

    pageArray.map(function (p) {
      if (p[0].includes(rowData.entityID)) {
        if (p[1].percentComplete > 0) {
          entityStatus = 'Continue';
        }
        if (p[1].percentComplete !== 100) {
          allPagesDone = false;
        }
      } else {
        allPagesDone = false;
      }
      if (rowData.progress === 1) {
        allPagesDone = true;
      }
    });
  }
  if (!(0, _lodash.isEmpty)(pageProgress) && allPagesDone) {
    entityStatus = 'Completed';
  }
  if (action.type === 'status') {
    /* if (rowData.status === 'Not Started' || rowData.status === null) {
       return getResource(resources, language, 'Label', 'Start');
     } else {
       return getResource(resources, language, 'Label', rowData.status);
     }*/

    return (0, _getResource.getResource)(resources, language, 'Label', entityStatus);
  } else if (action.type === 'delegate') {
    if (rowData.delegates) {
      return [action.icon, rowData.delegates.users.length > 0 ? "".concat(rowData.delegates.users.length, " ").concat(rowData.delegates.users.length === 1 ? 'FACILITY DELEGATE' : 'FACILITY DELEGATES') : 'FACILITY DELEGATE'];
    } else {
      return [action.icon, 'FACILITY DELEGATE'];
    }
  }
  return action.text;
};
var getButtonVariant = function getButtonVariant(action, rowData) {
  if (action.type === 'delegate' && rowData.delegates) {
    return rowData.delegates.users.length > 0 ? 'outlined' : action.component.props.variant;
  }
  return action.component.props.variant;
};
var styles = function styles() {
  return {
    actionButtons: {
      cursor: 'pointer',
      "float": 'right',
      padding: '.375rem .75rem'
    }
  };
};
var ActionsColumn = exports.ActionsColumn = (0, _styles.withStyles)(styles)(function (props) {
  var actions = props.actions,
    _props$width = props.width,
    width = _props$width === void 0 ? 240 : _props$width,
    classes = props.classes,
    resources = props.resources,
    language = props.language,
    pageProgress = props.pageProgress;
  var tableColumnsComputed = function tableColumnsComputed(_ref) {
    var tableColumns = _ref.tableColumns;
    return tableColumnsWithActions(tableColumns, width);
  };
  return /*#__PURE__*/_react["default"].createElement(_dxReactCore.Plugin, {
    name: "ActionsColumn",
    dependencies: pluginDependencies
  }, /*#__PURE__*/_react["default"].createElement(_dxReactCore.Getter, {
    name: "tableColumns",
    computed: tableColumnsComputed
  }), /*#__PURE__*/_react["default"].createElement(_dxReactCore.Template, {
    name: "tableCell",
    predicate: function predicate(_ref2) {
      var tableRow = _ref2.tableRow,
        tableColumn = _ref2.tableColumn;
      return isHeadingActionsTableCell(tableRow, tableColumn);
    }
  }, /*#__PURE__*/_react["default"].createElement(_dxReactGridMaterialUi.Table.Cell, null, "Actions Column")), /*#__PURE__*/_react["default"].createElement(_dxReactCore.Template, {
    name: "tableCell",
    predicate: function predicate(_ref3) {
      var tableRow = _ref3.tableRow,
        tableColumn = _ref3.tableColumn;
      return isActionsTableCell(tableRow, tableColumn);
    }
  }, function (params) {
    return /*#__PURE__*/_react["default"].createElement(_dxReactGridMaterialUi.Table.Cell, (0, _extends2["default"])({}, params, {
      row: params.tableRow.row
    }), actions.filter(function (action) {
      if (action.type === 'delegate') {
        var _params$tableRow$row = params.tableRow.row,
          delegates = _params$tableRow$row.delegates,
          email = _params$tableRow$row.email,
          hasDelegatePermission = _params$tableRow$row.hasDelegatePermission;
        if (delegates) {
          return hasDelegatePermission || delegates.users && (0, _lodash.findIndex)(delegates.users, {
            email: email
          }) !== -1 ? true : false;
        } else {
          return hasDelegatePermission;
        }
      }
      return true;
    }).map(function (action, index) {
      if (action.type !== 'delegate') {
        if (params.tableRow.key.toString().match(/heading/) !== null) {
          return '';
        }
        var rowID = params.tableRow.rowId;
        var componentWithProps = /*#__PURE__*/(0, _react.cloneElement)(action.component, {
          onClick: function onClick(event) {
            return action.action(event, rowID);
          },
          children: getActionText(action, params.tableRow.row, resources, language, pageProgress),
          variant: getButtonVariant(action, params.tableRow.row)
        });
        return componentWithProps;
      }
    }));
  }));
});